<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.el-checkbox__inner{
  border: 1px solid #999;
}
.el-table thead{
  color:#2c3e50
}
html,body,#app,.el-container {
  padding: 0px;
  margin: 0px;
  height: 100%;
}
.el-breadcrumb {
    font-size: 14px;
    line-height: 2;
}
.uploadbox {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.dividerLine{
  border-left: 5px solid #409eff;
  padding-left: 10px;
  line-height: 20px;
  font-weight: bold;
  font-size: 14px;
}
.ellipsis1{
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}
.ellipsis2{
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.mar10{
  margin-left: 10px;
}
.martop10{
  margin-top: 10px;
}
.blue{
  color:#409eff
}
.red{
  color:red
}
.el-pagination {
    text-align: right;
}
.wid25{
  width: 25%;
}
.wid50{
  width: 50%;
}
.wid100{
  width: 100%;
}
.fontbold{
  font-weight: bold;
}
.inblock{
  display: inline-block;
}
.mar0{
  margin: 0;
}
.textcenter{
  text-align:center;
}
.tipsbox{
  padding: 1em;
  background: #ffe5be;
  font-size: 12px;
  color: #5c5e61;
}
.grayFont{
  color: #999;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
}
.uploadbox{
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width:100px;
  height:100px;
}
.fontSize18{
  font-size: 18px;
}
.fontSize16{
  font-size: 16px;
}
.fontSize12{
  font-size: 12px;
}
.normalFont{
  font-style: normal;
}
.lineheight30{
  line-height:30px;
}
.lineheight48{
  line-height:48px;
}
.left{
  float: left;
}
.right{
  float: right;
}
.slh{
  overflow: hidden;/*内容超出后隐藏*/
  text-overflow: ellipsis;/*超出部分以省略号显示*/
  white-space: nowrap;/*文本不进行换行*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue